import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { APICore } from 'helpers/api/apiCore';
import useRedux from 'hooks/useRedux';
import { RootState } from 'redux/store';
import { useIdleTimer } from 'react-idle-timer';

type PrivateRouteProps = {
    component: React.ComponentType;
    roles?: string;
};

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: RouteComponent, roles, ...rest }: PrivateRouteProps) => {
    let location = useLocation();
    const { appSelector } = useRedux();
    const { user: loggedInUser } = appSelector((state: RootState) => ({
        user: state.Auth.user,
    }));

    const api = new APICore();
    const navigate = useNavigate()

    const onIdle = () => {
        navigate('/account/logout')
    }

    useIdleTimer({
        onIdle,
        timeout: 1000 * 60 * 60,
        throttle: 500,
        disabled: loggedInUser === null
    })

    /**
     * not logged in so redirect to login page with the return url
     */
    if (api.isUserAuthenticated() === false) {
        return <Navigate to={'/account/login'} state={{ from: location }} replace />;
    }

    // check if route is restricted by role
    if (roles && roles.indexOf(loggedInUser.role) === -1) {
        // role not authorised so redirect to home page
        return <Navigate to={{ pathname: '/' }} />;
    }

    return <RouteComponent />;
};

export default PrivateRoute;
